import {APIError} from 'data/errors/api-error';
import {HttpClient, HttpStatusCode} from 'data/protocols/http';
import {PatchConfirmAddressV4, PatchConfirmAddressV4Params} from 'domain/usecases';

export class RemotePatchConfirmAddressV4 implements PatchConfirmAddressV4 {
	constructor(
		private readonly url: string,
		private readonly httpClient: HttpClient<unknown>,
	) {}

	async patch(params: PatchConfirmAddressV4Params): Promise<void> {
		const {signal} = params;

		const httpResponse = await this.httpClient.request({
			url: this.url,
			method: 'patch',
			signal,
		});

		switch (httpResponse.status) {
			case HttpStatusCode.ok:
			case HttpStatusCode.created:
			case HttpStatusCode.noContent:
				return;
			default:
				throw new APIError(httpResponse.status, httpResponse.data);
		}
	}
}
